import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { toast } from "react-toastify"
import api, { timeout } from "../../api"
import { setMessage } from "../message/messageSlice"

export const getsupportadmindashboard = createAsyncThunk(
  "supportdashboard/getsupportadmindashboard",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `portal/payments/v1/dashboard/support/admin`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

export const getsupportlivefeed = createAsyncThunk(
  "supportdashboard/getsupportlivefeed",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `portal/payments/v1/dashboard/support/live-feed`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)
export const getgovtpersonaldashboard = createAsyncThunk(
  "supportdashboard/getgovtpersonaldashboard",
  async ({}, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `portal/payments/v1/dashboard/government/personal`
      )
      return response?.data
    } catch (error) {
      return rejectWithValue()
    }
  }
)

const initialState = {
  data: null,
  loading: false,
  personal: null,
  feed: null,
}

const supportdashboardSlice = createSlice({
  name: "supportdashboard",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getsupportadmindashboard.pending, (state) => {
      state.loading = true
      state.data = null
    })
    builder.addCase(
      getsupportadmindashboard.fulfilled,
      (state, { payload }) => {
        state.loading = false
        state.data = payload.data
      }
    )
    builder.addCase(getsupportadmindashboard.rejected, (state) => {
      state.data = null
      state.loading = false
    })
    builder.addCase(getsupportlivefeed.fulfilled, (state, { payload }) => {
      state.feed = payload.data
    })
    builder.addCase(
      getgovtpersonaldashboard.fulfilled,
      (state, { payload }) => {
        state.personal = payload.data
      }
    )
  },
})

export default supportdashboardSlice.reducer
